import {ActionTree} from "vuex";
import {SmppConnectionItem, SmppConnectionState} from "@/store/settings/smpp_connections/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<SmppConnectionState, RootState> = {
  getSmppConnections: ({commit}, data) => {
      commit('setLoading', true);
      return new Promise((resolve, reject) => {
      axios({url: '/acapi/service_providers/connections/smpp', params: data})
        .then(resp => {
          commit('setSmppConnections', resp.data.connections);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getSmppConnectionItem: ({commit, dispatch},id) => {
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/service_providers/connections/smpp/${id}`})
        .then((resp:any) => {
          let smppConnectionItem = <SmppConnectionItem>resp.data;
          smppConnectionItem.id = id;
          commit('setSmppConnectionItem', smppConnectionItem);
          resolve(smppConnectionItem)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  saveSmppConnection: ({commit, dispatch}, data:SmppConnectionItem) => {
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/service_providers/connections/smpp/' + (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getSmppConnections');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
    })
  },
  deleteSmppConnection: ({commit, dispatch}, data: SmppConnectionItem) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/service_providers/connections/smpp/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getSmppConnections');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
    })
  },
  getServerNames: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/jmx/server_names', params: data})
        .then(resp => {
          commit('setServerNames', resp.data.server_names);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
